@media screen {
    .grid-container {
        background-color: var(--blue-bg);
        background-image: url('/include/images/auth/two-clouds.svg');
        background-size: cover;
        background-position: right;
        background-repeat: no-repeat;
        height: 100%;
        width: 100%;
    }

    .grid {
        display: grid;
        grid-template-columns: 6fr 4fr;
        grid-template-rows: repeat(4, auto);
        gap: 24px 32px;
        padding: 16px 64px;
        box-sizing: border-box;
        min-height: 100vh;
        height: 100%;
        width: 100%;
    }

    .main-header {
        grid-column: 1/3;
        grid-row: 1/2;
    }

    .left-content {
        grid-column: 1/2;
        grid-row: 2/4;
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: center;
        max-width: 700px;
        width: 100%;
        justify-self: center;
    }

    .header {
        max-width: 725px;
        font-size: 42px;
        color: var(--sidebar-primary);
        text-align: center;
        font-style: normal;
        font-family: 'Doyle', 'Georgia', 'sans-serif';
        font-weight: 700;
        line-height: 54.6px;
    }

    .image-container {
        display: flex;
        width: 100%;
    }

    .form {
        grid-column: 2/3;
        grid-row: 2/4;
        background-color: #fff;
        padding: 48px 64px;
        border-radius: 8px;
        box-shadow: 0 0 10px 0 rgba(60, 106, 120, 0.24);
        height: fit-content;
        width: fit-content;
        justify-self: center;
        align-self: center;
    }
}

@media (max-width: 1100px) {
    .grid-container {
        min-height: 100vh;
        height: fit-content;
    }

    .grid {
        grid-template-columns: 1fr;
        grid-template-rows: repeat(4, auto);
        padding: 16px 32px;
    }

    .left-content {
        grid-column: initial;
        align-items: center;
        grid-row: 2/3;
    }

    .main-header {
        grid-column: initial;
    }

    .header {
        font-size: max(28px, 3.3vw);
        line-height: 48px;
        padding-top: 32px;
    }

    .form {
        grid-column: initial;
        grid-row: 3/4;
    }

    .image-container {
        display: none;
    }
}

@media (max-width: 744px) {
    .header {
        font-size: 28px;
        line-height: 40px;
    }

    .form {
        padding: 48px 32px;
    }
}
